import { en } from '@formkit/i18n';
import { generateClasses } from '@formkit/themes';
import { genesisIcons } from '@formkit/icons';
import { formkitTailwind } from '../theme/formkitTailwind';
import { formkitCustoms } from '../form/index';
import { IconsFlatObject } from '../helpers';
import { createAutoHeightTextareaPlugin } from '@formkit/addons';
import { createProPlugin, inputs } from '@formkit/pro';

import { Plugin } from 'vue';
import { plugin, defaultConfig, DefaultConfigOptions } from '@formkit/vue';

export const formKitPlugin: [Plugin, DefaultConfigOptions] = [
  plugin,
  defaultConfig({
    locales: { en },
    locale: 'en',
    icons: {
      ...genesisIcons,
      ...IconsFlatObject(),
    },
    inputs: formkitCustoms,
    config: {
      classes: generateClasses(formkitTailwind),
    },
    plugins: [createAutoHeightTextareaPlugin(), createProPlugin('fk-505eb7adb0', inputs)],
  }),
];
